import { AMBIENTE, KEYCLOAK_REALM } from "./env";

export function identificarAmbiente(
  configurado = AMBIENTE,
  realm = KEYCLOAK_REALM,
  hostname = window.location.hostname
) {
  const value = String(configurado || "")
    .trim()
    .toUpperCase();
  if (["PRD", "PROD", "PRODUCAO", "PRODUÇÃO"].includes(value))
    return "Produção";
  if (["HOM", "HOMOLOGACAO", "HOMOLOGAÇÃO"].includes(value))
    return "Homologação";
  if (["DEV", "DESENVOLVIMENTO"].includes(value)) return "Desenvolvimento";
  if (value === "LOCAL") return "Local";
  if (value) return String(configurado).trim();
  if (["localhost", "127.0.0.1", "[::1]"].includes(hostname)) return "Local";
  if (realm === "DPGE-HOM") return "Homologação";
  if (realm === "DPGE") return "Produção";
  return "Não informado";
}
